import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { getQuizResults } from '../../services/api';
import DarkModeToggle from '../../components/DarkModeToggle/DarkModeToggle';
import './Results.css';

const Results = () => {
  const { resultId } = useParams();
  const { handleRequest, loading } = useApi();
  const [results, setResults] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const immediateResults = location.state?.results;

  useEffect(() => {
    // If resultId is "dashboard" or invalid, redirect to dashboard
    if (resultId === 'dashboard' || (resultId && !resultId.match(/^[0-9a-fA-F]{24}$/))) {
      navigate('/dashboard');
      return;
    }

    if (!immediateResults && resultId) {
      const fetchResults = async () => {
        try {
          const response = await handleRequest(getQuizResults, resultId);
          setResults(response.data);
        } catch (error) {
          console.error('Failed to fetch results:', error);
          // If result not found, redirect to dashboard
          navigate('/dashboard');
        }
      };
      fetchResults();
    } else if (immediateResults) {
      setResults(immediateResults);
    } else if (!resultId && !immediateResults) {
      // No resultId and no immediate results, redirect to dashboard
      navigate('/dashboard');
    }
  }, [resultId, handleRequest, immediateResults, navigate]);

  if (loading || !results) {
    return <div className="results-container">Laster resultater...</div>;
  }

  return (
    <div className="results-container">
      <header className="results-header">
        <div className="results-header-top">
          <button 
            type="button" 
            className="back-button" 
            onClick={() => navigate('/dashboard')}
            title="Tilbake til oversikten"
          >
            ← Tilbake
          </button>
          <h1>Quizresultater</h1>
          <DarkModeToggle />
        </div>
        <div className="score-summary">
          <h2>Sluttresultat: {results.score}%</h2>
          <p>Riktige svar: {results.correctCount} av {results.totalQuestions}</p>
        </div>
      </header>

      <main className="results-content">
        <div className="questions-review">
          {results.answers.map((answer, index) => (
            <div 
              key={index} 
              className={`question-result ${answer.isCorrect ? 'correct' : 'incorrect'}`}
            >
              <h3>Spørsmål {index + 1}</h3>
              <p className="question-text">{answer.question}</p>
              <div className="answer-details">
                <p><strong>Ditt svar:</strong> {answer.userAnswer}</p>
                <p><strong>Riktig svar:</strong> {answer.correctAnswer}</p>
                <p className="explanation"><strong>Forklaring:</strong> {answer.explanation}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="results-actions">
          <button onClick={() => navigate('/dashboard')} className="home-btn">
            Tilbake til oversikten
          </button>
          <button onClick={() => window.print()} className="print-btn">
            Skriv ut resultater
          </button>
        </div>
      </main>
    </div>
  );
};

export default Results; 